import {KpiOption} from '@hconnect/common/types'

import {KpiNamesResponse, KpiUnitOption} from '../types'

export const mapUnitsToOptions = (units: string[]): KpiUnitOption[] =>
  units.map((unit) => ({
    id: unit,
    label: unit
  }))

export const mapKpiOptions = (options: KpiNamesResponse): KpiOption[] =>
  options.map((option) => ({
    id: option,
    label: option
  }))
